module.exports = "<div class=\"consumer-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>\r\n\r\n\r\n"